// import React, { useEffect } from "react";
// import { useState } from "react";
// import { FaLanguage } from "react-icons/fa6";

// const setCookie = (name, value, days) => {
//   const date = new Date();
//   date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
//   document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
// };

// const GoogleTranslate = () => {
//   const [selectedLanguage, setSelectedLanguage] = useState();
//   useEffect(() => {
//     try {
//       loadGoogleTranslateScript();
//     } catch (error) {
//       console.error("Error during useEffect:", error);
//     }
//   }, []);

//   const loadGoogleTranslateScript = () => {
//     try {
//       const scriptExists = document.querySelector("script[src*='translate']");
//       if (!scriptExists) {
//         const script = document.createElement("script");
//         script.src =
//           "https://translate.google.com/translate_a/element.js?cb=initializeGoogleTranslate";
//         document.body.appendChild(script);
//         window.initializeGoogleTranslate = () => {
//           try {
//             new window.google.translate.TranslateElement(
//               { pageLanguage: "en" },
//               "google_translate_element"
//             );
//           } catch (error) {
//             console.error("Error initializing Google Translate:", error);
//           }
//         };
//       }
//     } catch (error) {
//       console.error("Error loading Google Translate script:", error);
//     }
//   };

//   const handleLanguageChange = (event) => {
//     try {
//       const language = event.target.getAttribute("data-lang");
//       setSelectedLanguage(language);

//       setCookie("googtrans", `/en/${language}`, 365);

//       if (window.google?.translate?.TranslateElement) {
//         const select = document.querySelector(".goog-te-combo");
//         if (select) {
//           select.value = language;
//           select.dispatchEvent(new Event("change"));
//         }
//       }
//     } catch (error) {
//       console.error("Error during language change:", error);
//     }
//   };

//   return (
//     <>
//       <style>
//         {`
//          .goog-logo-link, .goog-te-gadget-icon {
//             display: none !important;
//           }
//           .goog-te-banner-frame.skiptranslate {
//             display: none !important;
//           }
//           body {
//             top: 0 !important;
//           }
//           .google-translate-container {
//             display: inline-flex;
//             align-items: center;
//             cursor: pointer;
//           }

//           .goog-te-combo {
//             visibility: hidden;
//             position: absolute;
//             border: none !important;
//             background-color: transparent !important;
//           }
//           .goog-te-combo option:first-child {
//             display: none;
//           }
//           .goog-te-gadget-simple {
//             background-color: transparent;
//             border: none !important;
//             padding: 0px;
//           }
//           a.VIpgJd-ZVi9od-xl07Ob-lTBxed {
//             display: flex;
//             justify-content: center; /* Centering the symbol ▼ */
//             align-items: center; /* Vertically center the  symbol ▼ */
//         }

//         a.VIpgJd-ZVi9od-xl07Ob-lTBxed span {
//             display: none; /* Hide all span elements */
//         }

//         a.VIpgJd-ZVi9od-xl07Ob-lTBxed span[aria-hidden="true"] {
//             display: inline-block; /* Only show the symbol ▼ */
//         }
//         .skiptranslate iframe {
//           display: none !important;
//         }
//      `}
//         {`
//     /* Responsive styling for mobile devices */
//         @media (max-width: 768px) {
//             .dropdown-menu {
//               position: absolute;
//               width: auto;
//               max-width: 100px; /* Set a maximum width for compactness */
//               left: 50%; /* Center align */
//               transform: translateX(-50%); /* Center horizontally */
//               box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Shadow for visibility */
//                z-index: 1000;
//       }

//       .dropdown-menu-columns {
//         flex-direction: column; /* Stack columns vertically */
//       }

//       .dropdown-menu-column {
//         width: 100%; /* Ensure items stack properly */
//       }

//       .dropdown-item {
//         padding: 8px 12px; /* Smaller padding for compactness */
//         font-size: 14px; /* Reduce font size slightly */
//       }

//       .divMain {
//         margin-right:12px;
//         margin-bottom: 0px !important;
//       }
//     }
//   `}
//       </style>
//       <li
//         className="nav-item dropdown divMain "
//         style={{ marginBottom: "13px" }}
//       >
//         <span
//           className="nav-link dropdown-toggle"
//           href="#navbar-layout"
//           data-bs-toggle="dropdown"
//           data-bs-auto-close="outside"
//           role="button"
//           aria-expanded="false"
//         >
//           {"  "}
//           <span className="nav-link-title notranslate text-uppercase align-center">
//             <b className="mt-2">{selectedLanguage}</b>
//             {"  "}
//             <FaLanguage className="fs-1" />
//           </span>
//         </span>
//         <div className="dropdown-menu">
//           <div className="dropdown-menu-columns">
//             <div className="dropdown-menu-column">
//               <span
//                 className="dropdown-item notranslate w-auto"
//                 data-lang="en"
//                 onClick={handleLanguageChange}
//               >
//                 English (English)
//               </span>
//               <span
//                 className="dropdown-item notranslate"
//                 data-lang="mr"
//                 onClick={handleLanguageChange}
//               >
//                 Marathi (मराठी)
//               </span>
//               <span
//                 className="dropdown-item notranslate"
//                 data-lang="gu"
//                 onClick={handleLanguageChange}
//               >
//                 Gujarati (ગુજરાતી)
//               </span>
//               <span
//                 className="dropdown-item notranslate"
//                 data-lang="ta"
//                 onClick={handleLanguageChange}
//               >
//                 Tamil (தமிழ்)
//               </span>
//               <span
//                 className="dropdown-item notranslate"
//                 data-lang="ar"
//                 onClick={handleLanguageChange}
//               >
//                 Arabic (عربي)
//               </span>
//               <span
//                 className="dropdown-item notranslate"
//                 data-lang="hi"
//                 onClick={handleLanguageChange}
//               >
//                 Hindi (हिन्दी)
//               </span>
//               <span
//                 className="dropdown-item notranslate"
//                 data-lang="bn"
//                 onClick={handleLanguageChange}
//               >
//                 Bengali (বাংলা)
//               </span>
//               <span
//                 className="dropdown-item notranslate"
//                 data-lang="pa"
//                 onClick={handleLanguageChange}
//               >
//                 Punjabi (ਪੰਜਾਬੀ)
//               </span>
//               <span
//                 className="dropdown-item notranslate"
//                 data-lang="te"
//                 onClick={handleLanguageChange}
//               >
//                 Telugu (తెలుగు)
//               </span>
//               <span
//                 className="dropdown-item notranslate"
//                 data-lang="kn"
//                 onClick={handleLanguageChange}
//               >
//                 Kannada (ಕನ್ನಡ)
//               </span>
//               <span
//                 className="dropdown-item notranslate"
//                 data-lang="ml"
//                 onClick={handleLanguageChange}
//               >
//                 Malayalam (മലയാളം)
//               </span>
//             </div>
//           </div>
//         </div>
//       </li>
//       <div id="google_translate_element" style={{ display: "none" }}></div>
//     </>
//   );
// };

// export default GoogleTranslate;
import React, { useEffect, useState } from "react";
import { FaLanguage } from "react-icons/fa6";

const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
};

const GoogleTranslate = () => {
  const [selectedLanguage, setSelectedLanguage] = useState("EN");
  const [isReady, setIsReady] = useState(false);
  const [isTranslating, setIsTranslating] = useState(false);

  useEffect(() => {
    loadScript();
  }, []);

  const loadScript = () => {
    if (window.googleTranslateLoaded) {
      waitForCombo();
      return;
    }

    const script = document.createElement("script");
    script.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateInit";
    script.async = true;

    window.googleTranslateInit = () => {
      new window.google.translate.TranslateElement(
        { pageLanguage: "en" },
        "google_translate_element"
      );
      window.googleTranslateLoaded = true;
      waitForCombo();
    };

    document.body.appendChild(script);
  };

  // wait until Google injects dropdown
  const waitForCombo = () => {
    const interval = setInterval(() => {
      const combo = document.querySelector(".goog-te-combo");
      if (combo) {
        setIsReady(true);
        clearInterval(interval);
      }
    }, 200);
  };

  const handleLanguageChange = (lang) => {
    if (!isReady) return;

    setSelectedLanguage(lang.toUpperCase());
    setIsTranslating(true);

    setCookie("googtrans", `/en/${lang}`, 365);

    const combo = document.querySelector(".goog-te-combo");

    if (combo) {
      combo.value = lang;

      // delay ensures smooth trigger
      setTimeout(() => {
        combo.dispatchEvent(new Event("change"));
        setIsTranslating(false);
      }, 300);
    } else {
      setIsTranslating(false);
    }
  };

  return (
    <>
      <style>
        {`
          .goog-logo-link,
          .goog-te-gadget-icon {
            display: none !important;
          }

          .goog-te-banner-frame.skiptranslate {
            display: none !important;
          }

          body {
            top: 0 !important;
          }

          .goog-te-combo {
            visibility: hidden;
            position: absolute;
          }

          .skiptranslate iframe {
            display: none !important;
          }
        `}
      </style>

      <li className="dropdown">
        <span
          className="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          role="button"
        >
          <span className="nav-link-title notranslate text-uppercase">
            <b>{selectedLanguage}</b> <FaLanguage />
          </span>
        </span>

        <div className="dropdown-menu">
          {[
            { code: "en", label: "English (English)" },
            { code: "mr", label: "Marathi (मराठी)" },
            { code: "gu", label: "Gujarati (ગુજરાતી)" },
            { code: "ta", label: "Tamil (தமிழ்)" },
            { code: "ar", label: "Arabic (عربي)" },
            { code: "hi", label: "Hindi (हिन्दी)" },
            { code: "bn", label: "Bengali (বাংলা)" },
            { code: "pa", label: "Punjabi (ਪੰਜਾਬੀ)" },
            { code: "te", label: "Telugu (తెలుగు)" },
            { code: "kn", label: "Kannada (ಕನ್ನಡ)" },
            { code: "ml", label: "Malayalam (മലയാളം)" },
          ].map((lang) => (
            <span
              key={lang.code}
              className="dropdown-item notranslate"
              onClick={() => handleLanguageChange(lang.code)}
            >
              {lang.label}
            </span>
          ))}
        </div>
      </li>

      {/* hidden google container */}
      <div id="google_translate_element" style={{ display: "none" }} />

      {/* optional loader */}
      {isTranslating && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            background: "#00000080",
            color: "#fff",
            textAlign: "center",
            padding: "5px",
            zIndex: 9999,
          }}
        >
          Translating...
        </div>
      )}
    </>
  );
};

export default GoogleTranslate;
